import { AppSeo } from "@/components/AppSeo";
import { useWorkspace } from "@/hooks/useWorkspace";
import { tierEntitlements } from "@/lib/tier";
import { WorkspaceMediaPanel } from "@/components/composer/draft/WorkspaceMediaPicker";

const WorkspaceMedia = () => {
  const { active } = useWorkspace();
  const capBytes = tierEntitlements(active?.account_tier ?? null).workspaceMediaBytes;

  return (
    <>
      <AppSeo title="Workspace Media" />
      <div className="flex min-h-0 flex-col gap-4">
        <div className="space-y-1">
          <h1 className="font-serif text-2xl font-semibold sm:text-3xl">Workspace Media</h1>
          <p className="text-sm text-muted-foreground">
            Reusable image library for this workspace. Drop images here once, then drag them
            from the Composer's Media tab into any draft. Deleted images are restorable for 24 hours.
          </p>
        </div>
        {active ? (
          <WorkspaceMediaPanel workspaceId={active.id} capBytes={capBytes} managerOnly />
        ) : (
          <div className="rounded-md border border-dashed p-6 text-center text-sm text-muted-foreground">
            Select a workspace to manage its media.
          </div>
        )}
      </div>
    </>
  );
};

export default WorkspaceMedia;
